import Discount from '@/models/Cart/Discount'
import DeliveryCharge from '@/models/Cart/DeliveryCharge'

class PriceOperationPolicy {
  constructor({ minimumOrderPrice, discounts, deliveryCharges, defaultDeliveryCharge }) {
    this.minimumOrderPrice = minimumOrderPrice
    this.discounts = discounts.map((discount) => new Discount(discount))
    this.deliveryCharges = deliveryCharges.map((deliveryCharge) => new DeliveryCharge(deliveryCharge))
    this.defaultDeliveryCharge = defaultDeliveryCharge

    this.reverseDeliveryCharges = this.deliveryCharges.slice().reverse()
  }

  getMinimumOrderPrice() {
    return this.minimumOrderPrice
  }

  getDefaultDeliveryCharge() {
    return this.defaultDeliveryCharge
  }

  get getDiscounts() {
    return this.discounts
  }

  getDeliveryCharges() {
    return this.deliveryCharges
  }

  getReverseDeliveryCharges() {
    return this.reverseDeliveryCharges
  }
}

export default PriceOperationPolicy
